<script lang="ts" setup>
// Barre de navigation desktop : entrées principales, dépliant « AUTRES », et
// les cloches alignées à droite. Masquée sous `md`, où le tiroir prend le relais.
import {
  HEADER_MENU_AUTRES,
  HEADER_MENUS_PRIMAIRES,
  HEADER_MENUS_SECONDAIRES,
  isHeaderMenuActive,
} from '~/utils/headerMenus'

const route = useRoute()
const showAutresDropdown = ref(false)

// Mise en forme commune aux entrées de la barre et au dépliant « AUTRES ».
const ENTRY_CLASS = 'flex flex-col items-center px-3 py-3 cursor-pointer transition text-xs h-full w-36 justify-center hover:bg-primary hover:text-white'
</script>

<template>
  <div class="w-full h-full items-center md:flex hidden">
    <div class="flex w-full justify-center h-full items-center">
      <NuxtLink
        v-for="menu in HEADER_MENUS_PRIMAIRES"
        :key="menu.name"
        :to="menu.href"
        :class="[
          ENTRY_CLASS,
          isHeaderMenuActive(menu, route.path) ? 'text-white bg-primary' : 'bg-white text-black',
        ]"
      >
        <Icon :name="menu.icon" class="text-base mb-2 shrink-0" />
        <!-- Hauteur fixe (2 lignes) pour tous les libellés : les icônes restent
             alignées même quand un libellé passe sur deux lignes. -->
        <span class="flex h-9 items-center justify-center text-center leading-tight">
          {{ menu.name }}
        </span>
      </NuxtLink>

      <div
        class="relative h-full"
        @mouseenter="showAutresDropdown = true"
        @mouseleave="showAutresDropdown = false"
      >
        <NuxtLink
          :to="HEADER_MENU_AUTRES.href || '#'"
          class="text-black"
          :class="ENTRY_CLASS"
        >
          <Icon :name="HEADER_MENU_AUTRES.icon" class="text-base mb-2 shrink-0" />
          <span class="flex h-9 items-center justify-center text-center leading-tight">
            {{ HEADER_MENU_AUTRES.name }}
          </span>
        </NuxtLink>
        <div
          v-if="showAutresDropdown"
          class="absolute left-0 mt-0 w-64 rounded-none shadow-2xl bg-white ring-1 ring-black ring-opacity-5 z-50 py-1"
        >
          <NuxtLink
            v-for="item in HEADER_MENUS_SECONDAIRES"
            :key="item.name"
            :to="item.href"
            class="flex items-center px-4 py-2 text-gray-700 hover:bg-primary hover:text-white transition"
          >
            <Icon :name="item.icon" class="mr-2" />
            {{ item.name }}
          </NuxtLink>
          <hr class="border-black border-1 mx-6 my-4">
          <HeaderContactLinks />
        </div>
      </div>
    </div>

    <NotificationBadges class="ml-auto" />
  </div>
</template>
